import React, { useState } from "react";
import {Helmet} from "react-helmet";
import abonentCover from "./abonent-cover.jpg"
import axios from "axios";

const AbonentDonacija = () => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [selectedTip, setSelectedTip] = useState("");
    const [ime, setIme] = useState("");


    const [privacyChecked, setPrivacyChecked] = useState(false);
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!privacyChecked) {
            alert("Prosimo, da se strinjate s pravilnikom o zasebnosti.");
            return;
        }

        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/abonent/dodaj`, { name, email });
            setMessage(response.data.message);
            setName("");
            setEmail("");
        } catch (error) {
            setMessage("Napaka pri prijavi!");
            console.error(error);
        }
    };

    const [znesek, setZnesek] = useState("");


    const handleSubmitDonacija = async (e) => {
        e.preventDefault();

        try {
            const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/donacije`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    ime,
                    email,
                    znesek,
                    tip: selectedTip
                })
            });

            const data = await res.json();

            alert(data.message);
            setOpenModal(false);

        } catch (err) {
            console.error(err);
        }
    };


    return (
        <div className="onas-container">
            <Helmet>
                <title>SMA - Abonent</title>
                <meta name="description" content="S svojim trudom si želimo pomagati mladim slovenskim umetnikom, ki iščejo pot do profesionalne kariere" />
                <meta name="robots" content="index, follow" />
            </Helmet>

            <section className="onas-uvod">
                <div>
                    <div className="center">
                        <h2>Postani Abonent & Podpri Abonma</h2>
                    </div>
                </div>
            </section>


            <section className="postani-abonent-sekcija">
                <div className="abonent-wrapper">

                    <div className="postani-abonent-levo-slika">
                        <img src={abonentCover} alt="postani abonent"/>
                    </div>

                    <div className="abonent-section">
                        <h2>Postani abonent</h2>
                        <p className="abonent-section-p">
                            Za prejem novic in povabil na koncerte
                        </p>

                        <form onSubmit={handleSubmit}>
                            <input
                                type="text"
                                placeholder="Ime in priimek"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                required
                            />

                            <input
                                type="email"
                                placeholder="E-mail naslov"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />

                            <div className="checkbox-wrapper">
                                <input
                                    type="checkbox"
                                    id="privacy"
                                    checked={privacyChecked}
                                    onChange={(e) => setPrivacyChecked(e.target.checked)}
                                    required
                                />
                                <label htmlFor="privacy">
                                    Strinjam se s <a href="/pravilnik-zasebnosti">pogoji zasebnosti</a>.
                                </label>
                            </div>

                            <button type="submit">Prijavi se</button>
                        </form>

                        {message && <p>{message}</p>}
                    </div>
                </div>
            </section>


            <section className="donacije-sekcija">

                <div className="donacije-uvod">
                    <h2>Podpri Slovenski mladi abonma</h2>
                    <p>
                        Slovenski mladi abonma vodimo mladi glasbeniki, ki želimo svojo strast deliti med ljudi. Vaši prispevki so vsakoletno neizmernega pomena, saj nam omogočajo večjo neodvisnost od javnih sredstev, načrtovanje večjih investicij in višanje nivoja programa. Ker želimo za vedno ostati v Radovljici in tu vzgojiti svoje občinstvo, želimo najti čim več podpornikov iz lokalnega okolja, ki si želijo biti bolj vpleteni v naše delo in finančno ali kako drugače doprinesti k ohranjanju kvalitetne mlade klasične glasbe v Radovljiški graščini.

                    </p>
                </div>

                <div className="donacije-grid">

                    {/* PRIJATELJ */}
                    <div className="donacija-card">
                        <h3>Prijatelj abonmaja</h3>
                        <p className="cena">Donacija nad 10 €</p>

                        <ul>
                            <li>Prijava na novice</li>
                            <li>Prejem vabil na koncerte</li>
                            <li>Možnost donacije</li>
                            <li>Brošura + darilo (nad 10€)</li>
                        </ul>

                        <button onClick={() => {
                            setSelectedTip("prijatelj");
                            setOpenModal(true);
                        }}>
                            Več
                        </button>
                    </div>

                    {/* DOBROTNIK */}
                    <div className="donacija-card highlight">
                        <h3>Dobrotnik abonmaja</h3>
                        <p className="cena">50 € – 200 €</p>

                        <ul>
                            <li>Vse ugodnosti prijatelja</li>
                            <li>Posebno povabilo na koncert</li>
                            <li>Dostop do ekskluzivne vsebine</li>
                            <li>Popusti na produkte</li>
                        </ul>

                        <button onClick={() => {
                            setSelectedTip("dobrotnik");
                            setOpenModal(true);
                        }}>
                            Več
                        </button>
                    </div>

                    {/* MECEN */}
                    <div className="donacija-card">
                        <h3>Mecen abonmaja</h3>
                        <p className="cena">nad 200 €</p>

                        <ul>
                            <li>Vse ugodnosti dobrotnika</li>
                            <li>Stalna rezervacija sedeža</li>
                            <li>Osebna zahvala</li>
                            <li>Predčasen dostop do programa</li>
                            <li>Oseben kontakt z ekipo SMA</li>
                        </ul>

                        <button onClick={() => {
                            setSelectedTip("mecen");
                            setOpenModal(true);
                        }}>
                            Več
                        </button>
                    </div>
                </div>
                {/*<div className="donacija-custom">*/}
                {/*    <h2>Podpri nas po svoje</h2>*/}
                {/*    <p>Izberi poljuben znesek donacije</p>*/}

                {/*    <div className="donacija-input-row">*/}
                {/*        <input*/}
                {/*            type="number"*/}
                {/*            placeholder="Vnesi znesek (€)"*/}
                {/*            value={znesek}*/}
                {/*            onChange={(e) => setZnesek(e.target.value)}*/}
                {/*        />*/}

                {/*        <button onClick={handleDonacija}>*/}
                {/*            Doniraj*/}
                {/*        </button>*/}
                {/*    </div>*/}
                {/*</div>*/}
                {openModal && (
                    <div className="modal-overlay" onClick={() => setOpenModal(false)}>

                        <div className="modal-page" onClick={(e) => e.stopPropagation()}>

                            <button
                                className="modal-close"
                                onClick={() => setOpenModal(false)}
                            >
                                ✕
                            </button>

                            {/* LEVO */}
                            <div className="modal-left">

                                <h1>
                                    {selectedTip === "prijatelj" && "Prijatelj abonmaja"}
                                    {selectedTip === "dobrotnik" && "Dobrotnik abonmaja"}
                                    {selectedTip === "mecen" && "Mecen abonmaja"}
                                </h1>

                                <p className="modal-intro">
                                    {selectedTip === "prijatelj" &&
                                        "Za manjšo donacijo pa lahko na dom prejmete programsko brošuro celotne sezone, vabila na vse koncerte z osebno noto in majhno darilo naše ekipe.."
                                    }

                                    {selectedTip === "dobrotnik" &&
                                        "Za vsako donacijo nad 50 € prejmete vse ugodnosti prijatelja abonmaja, dodano pa bo posebno povabilo na koncert organizatorjev, ki bo zaprt za javnost in bo namenjen zahvali našim donatorjem in pokroviteljem. Poleg tega dobrotniki prejmejo tudi poseben dostop do vsebine, kot so posnetki koncertov, fotografije in intervjuji z izvajalci ter posebne ponudbe za zgoščenke in druge produkte, ki bodo nastali v okviru abonmaja.\n"
                                    }

                                    {selectedTip === "mecen" &&
                                        "Za vsako donacijo nad 200 € vam omogočimo vse zgoraj omenjene ugodnosti programov prijatelj in dobrotnik. Poleg njih meceni prejmejo stalno rezervacijo sedežev v dvorani po svoji izbiri, osebno zahvalo v programskih listih, promocijskem materialu in naši spletni strani ter predčasen dostop do programa naslednje sezone. Mecenom je ekipa SMA na voljo osebno za vsa vprašanja, ideje in doprinose k programu, prav tako z veseljem ponudimo možnosti nastopov naših sodelujočih umetnikov po dogovoru. "
                                    }
                                </p>

                                {/* BONITETE */}
                                <div className="benefits-grid">

                                    {(selectedTip === "prijatelj") && (
                                        <>
                                            <div className="benefit-card">Prijava na novice</div>
                                            <div className="benefit-card">Vabila na koncerte</div>
                                            <div className="benefit-card">Brošura sezone + darilo na dom</div>
                                            <div className="benefit-card">Tiskana vabila + programski list za vsak koncert na dom</div>
                                        </>
                                    )}

                                    {(selectedTip === "dobrotnik") && (
                                        <>
                                            <div className="benefit-card">Prijava na novice</div>
                                            <div className="benefit-card">Vabila na koncerte</div>
                                            <div className="benefit-card">Brošura sezone + darilo na dom</div>
                                            <div className="benefit-card">Tiskana vabila + programski list za vsak koncert na dom</div>
                                            <div className="benefit-card">Posebno vabilo na koncert organizatorjev</div>
                                            <div className="benefit-card">Dostop do dodatne vsebine (posnetki, fotografije, intervjuji)</div>
                                            <div className="benefit-card">Posebne ponudbe za zgoščenke in druge produkte</div>
                                        </>
                                    )}

                                    {(selectedTip === "mecen") && (
                                        <>
                                            <div className="benefit-card">Prijava na novice</div>
                                            <div className="benefit-card">Vabila na koncerte</div>
                                            <div className="benefit-card">Brošura sezone + darilo na dom</div>
                                            <div className="benefit-card">Tiskana vabila + programski list za vsak koncert na dom</div>
                                            <div className="benefit-card">Posebno vabilo na koncert organizatorjev</div>
                                            <div className="benefit-card">Dostop do dodatne vsebine (posnetki, fotografije, intervjuji)</div>
                                            <div className="benefit-card">Posebne ponudbe za zgoščenke in druge produkte</div>
                                            <div className="benefit-card">Stalna rezervacija sedežev po izbiri</div>
                                            <div className="benefit-card">Predčasen dostop</div>
                                            <div className="benefit-card">Osebna zahvala v programskih listih, na spletni strani...</div>
                                            <div className="benefit-card">Oseben kontakt z ekipo SMA</div>
                                            <div className="benefit-card">Možnost nastopov naših umetnikov po dogovoru</div>
                                        </>
                                    )}

                                </div>
                            </div>

                            {/* DESNO */}
                            <div className="modal-right">

                                <form onSubmit={handleSubmitDonacija} className="modal-form">

                                    <h2>Podpri abonma</h2>

                                    <div className="donacija-info">
                                        <p>
                                            Kulturno društvo Odeon <br/>
                                            Jelovška ulica 14 <br/>
                                            4240 Radovljica
                                        </p>
                                        <p>
                                            TRR: SI56 0400 0027 8624 875 <br/>
                                            OTP Banka
                                        </p>
                                        <p>
                                            Namen: <br/>
                                            DONACIJA - SMA26
                                        </p>
                                    </div>

                                    {/*<input*/}
                                    {/*    type="text"*/}
                                    {/*    placeholder="Ime in priimek"*/}
                                    {/*    value={ime}*/}
                                    {/*    onChange={(e) => setIme(e.target.value)}*/}
                                    {/*    required*/}
                                    {/*/>*/}

                                    {/*<input*/}
                                    {/*    type="email"*/}
                                    {/*    placeholder="Email"*/}
                                    {/*    value={email}*/}
                                    {/*    onChange={(e) => setEmail(e.target.value)}*/}
                                    {/*    required*/}
                                    {/*/>*/}

                                    {/*<input*/}
                                    {/*    type="number"*/}
                                    {/*    placeholder={*/}
                                    {/*        selectedTip === "prijatelj"*/}
                                    {/*            ? "Donacija nad 10 €"*/}
                                    {/*            : selectedTip === "dobrotnik"*/}
                                    {/*                ? "50 € – 200 €"*/}
                                    {/*                : "200 € +"*/}
                                    {/*    }*/}
                                    {/*    value={znesek}*/}
                                    {/*    onChange={(e) => setZnesek(e.target.value)}*/}
                                    {/*    required*/}
                                    {/*/>*/}

                                    {/*<button type="submit">*/}
                                    {/*    Potrdi donacijo*/}
                                    {/*</button>*/}

                                </form>

                            </div>

                        </div>
                    </div>
                )}
            </section>

        </div>
    );
};

export default AbonentDonacija;
